import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/analises-inconsistencias";

export const Route = createFileRoute("/_authenticated/analises-inconsistencias")({
  head: () => ({
    meta: [
      { title: "Avisos de inconsistência — Milky Moo Palmares" },
      {
        name: "description",
        content: "Inconsistências detectadas automaticamente nos cadastros do controle de estoque.",
      },
      { property: "og:title", content: "Avisos de inconsistência — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Inconsistências detectadas automaticamente nos cadastros do controle de estoque.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
